import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Box,
  HStack,
  Text
} from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { ProcessStatus } from 'models/types';

export interface StatusDropdownProps {
  value: ProcessStatus;
  onChange: (status: ProcessStatus) => void;
  size?: string;
}

const getStatusColor = (status: ProcessStatus): string => {
  switch (status) {
    case ProcessStatus.PENDING:
      return 'yellow.500';
    case ProcessStatus.APPROVED:
      return 'green.500';
    case ProcessStatus.REJECTED:
      return 'red.500';
    default:
      return 'gray.500';
  }
};

const StatusOption = ({ status }: { status: ProcessStatus }) => (
  <HStack spacing={2}>
    <Box
      width="8px"
      height="8px"
      borderRadius="full"
      backgroundColor={getStatusColor(status)}
    />
    <Text>{status}</Text>
  </HStack>
);

export default function StatusDropdown({
  value,
  onChange,
  size = 'md'
}: StatusDropdownProps) {
  const handleStatusClick = (status: ProcessStatus) => {
    onChange(status);
  };

  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        size={size}
        textAlign="left"
        width="100%"
      >
        <StatusOption status={value} />
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => handleStatusClick(ProcessStatus.PENDING)}>
          <StatusOption status={ProcessStatus.PENDING} />
        </MenuItem>
        <MenuItem onClick={() => handleStatusClick(ProcessStatus.APPROVED)}>
          <StatusOption status={ProcessStatus.APPROVED} />
        </MenuItem>
        <MenuItem onClick={() => handleStatusClick(ProcessStatus.REJECTED)}>
          <StatusOption status={ProcessStatus.REJECTED} />
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
